/* eslint-disable no-unused-vars */
import { useUrlQueryRef } from 'common-module/src/util/useUrlQueryRef';
import { ProjectInfo } from '@/store/modules/types/app';
import router from '@/router';
import store from '@/store';

const pidQuery = useUrlQueryRef<number>('pid', { parseData: (value) => Number(value) });

export const changeProject = async (param: ProjectInfo, isToKanbanPage: boolean) => {
  await store.dispatch('app/changeProject', {
    ...param,
    cb: () => {
      if (!isToKanbanPage) {
        pidQuery.value = param.id;
      }
      param.cb && param.cb();
    }
  });
  if (isToKanbanPage) {
    router.push('/kanban/list');
  }
};
